import axios from "axios";
import useCookie, {getCookie} from "react-use-cookie";


export const createUserAccount = async ({
                                            fname,
                                            mname,
                                            lname,
                                            email,
                                            phone,
                                            idtype,
                                            idnumber,
                                            countryid,
                                            address,
                                            contact_name,
                                            contact_email,
                                            contact_phone,
                                            userType,
                                            password,
                                            organization,
                                            password_confirmation,
                                            products,
                                            booths
                                        }) => {
    var data = JSON.stringify({
        "first_name": fname,
        "middle_name": mname,
        "last_name": lname,
        "email": email,
        "phone": phone,
        "id_type": idtype,
        "id_number": idnumber,
        "country_id": countryid ?? 112,
        "organization": organization,
        "address": address,
        "contact_person_name": contact_name,
        "contact_person_phone": contact_phone,
        "contact_person_email": contact_email,
        "products_services": products.toString(),
        "booths": booths,
        "user_type": userType,
        "password": password,
        "password_confirmation": password_confirmation
    });

    return axios({
        method: 'post',
        url: `${process.env.REACT_APP_BASE_URL}/api/register`,
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    });
}

export const loginUser = async ({email, password}) => {
    var data = JSON.stringify({
        "email": email,
        "password": password,
    });

    return axios({
        method: 'post',
        url: `${process.env.REACT_APP_BASE_URL}/api/login`,
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    });
}
export const requestPesapalPayment = async () => {

    let token = getCookie("summit_token", null)
    return axios({
        method: 'post',
        url: `${process.env.REACT_APP_BASE_URL}/api/payment/new`,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    });
}
export const downloadCertificate = async () => {

    let token = getCookie("summit_token", null)
    return axios({
        method: 'get',
        responseType: 'blob',
        url: `${process.env.REACT_APP_BASE_URL}/api/certificate/download`,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    });
}
export const paymentStatus = async () => {

    let token = getCookie("summit_token", null)
    return axios({
        method: 'get',
        url: `${process.env.REACT_APP_BASE_URL}/api/payment/status`,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    });
}
export const fetchRemainingSlots = async (userType) => {

    let token = getCookie("summit_token", null)
    return axios({
        method: 'get',
        url: `${process.env.REACT_APP_BASE_URL}/api/slots?user_type=${userType}`,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    });
}
export const setTransactionId = async (mpesa_transaction_id) => {

    let token = getCookie("summit_token", null)
    let user = JSON.parse(getCookie("summit_user", null))
    console.log(mpesa_transaction_id)
    return axios({
        method: 'put',
        url: `${process.env.REACT_APP_BASE_URL}/api/users/${user?.id}`,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        data: JSON.stringify({
            "mpesa_transaction_id": mpesa_transaction_id
        })
    });
}

export const allEvents = [
    {
        id: '1',
        title: 'Stand Up Against Childhood Cancer',
        description: 'Faraja Cancer Support invites you to a live webinar to discuss Childhood Cancer',
        content: '<div>Faraja Cancer Support invites you to a live webinar \r\nThe first part of the webinar we will discuss: Advancing development of comprehensive National Childhood Cancer Care by Dr Mary Nyangasi & The National Cancer Institute\'s Role in research on Childhood Cancer By Dr Alfred Karagu<br><br>\r\n\r\nThe second part we will discuss: Optimizing organizational collaborations and linkages in improving childhood cancer care by Jonathan Agin (Executive Director Max Cure Foundation, USA)<br><br>\r\n\r\nRegistration link: <a href="https://zoom.us/meeting/register/tJIpdeCprDMrEtbCE_BYyo9h-sC09NxIvKQm">https://zoom.us/meeting/register/tJIpdeCprDMrEtbCE_BYyo9h-sC09NxIvKQm</a><br><br>\r\n\r\nLogin details will be sent to your email after registering<br><br>\r\nFor more information kindly WhatsApp Faraja on <strong>0748811909</strong></div>',
        timestamp_from: 1715474145000,
        image: '/events/images/STAND UP AGAINST CHILDHOOD CANCER/IMG9.jpeg',
        gallery: ['/events/images/STAND UP AGAINST CHILDHOOD CANCER/IMG9.jpeg'],
        timestamp_to: 1715484145000,
        venue: 'Zoom',
        venue_link: 'event',
        isHtml: true,
        email: "",
        phone: "",
        category: 'event',
        canRegister: true,
        hasProgram: true,
    },
    {
        id: '2',
        title: 'National Cancer Institute of Kenya Sensitization workshop',
        description: 'National Cancer Institute of Kenya Sensitization workshop on The Cancer Prevention and Control Act 2012',
        content: '<div>National Cancer Institute of Kenya Sensitization workshop on The Cancer Prevention and Control Act 2012, The Kenya Cancer Policy 2019-2030, The National Cancer Registry and The Guidelines for Establishment of Cancer Management Centers to the County Health Management Teams of Bomet county, Kisii County, Kisumu County and Kakamega County<br><br></div>',
        timestamp_from: 1601321020,
        image: '/events/images/SensitizationWorkshop/151601293483_.pic.jpg',
        gallery: ['/events/images/SensitizationWorkshop/151601293483_.pic.jpg,/events/images/SensitizationWorkshop/101601293366_.pic.jpg,/events/images/SensitizationWorkshop/121601293418_.pic.jpg,/events/images/SensitizationWorkshop/131601293464_.pic.jpg,/events/images/SensitizationWorkshop/141601293476_.pic.jpg,/events/images/SensitizationWorkshop/161601293486_.pic.jpg,/events/images/SensitizationWorkshop/171601293488_.pic.jpg,/events/images/SensitizationWorkshop/181601293491_.pic.jpg,/events/images/SensitizationWorkshop/191601293493_.pic.jpg,/events/images/SensitizationWorkshop/201601293497_.pic.jpg,/events/images/SensitizationWorkshop/1601293367560443.mp4'],
        timestamp_to: 1601441020,
        venue: '',
        venue_link: 'news',
        isHtml: true,
        email: "",
        phone: "",
        category: 'news',
        canRegister: true,
        hasProgram: true,
    },
    {
        id: '3',
        title: 'World Cancer Day Virtual Launch',
        description: '',
        content: '<p><strong>Thursday, 4th February.</strong></p>\r\n<p><strong>Time: 9am - 11am.</strong></p>\r\n<p><strong>Zoom Meeting Link</strong></p>\r\n<p><strong>https://us05web.zoom.us/j/84618369685?pwd=T214a2hxQ3pmWitqU1gyazN5d3EzQT09</strong></p>\r\n<p><strong>Meeting ID: 846 1836 9685</strong></p>\r\n<p><strong>Passcode: 23njJL</strong></p>\r\n<table>\r\n<tbody>\r\n<tr>\r\n<td width="138">\r\n<p>Time</p>\r\n</td>\r\n<td width="300">\r\n<p>Topic</p>\r\n</td>\r\n<td width="186">\r\n<p>Panelist</p>\r\n</td>\r\n</tr>\r\n<tr>\r\n<td width="138">\r\n<p>9.00am</p>\r\n</td>\r\n<td width="300">\r\n<p>Climate setting/ welcoming attendees</p>\r\n</td>\r\n<td width="186">\r\n<p>Moderator &ndash; David &nbsp;Makumi</p>\r\n</td>\r\n</tr>\r\n<tr>\r\n<td width="138">\r\n<p>9.10am &ndash; 9.20am</p>\r\n</td>\r\n<td width="300">\r\n<p>Opening remarks</p>\r\n</td>\r\n<td width="186">\r\n<p>Dr. Ejersa Waqo &ndash; Head, Department of Non-communicable Diseases</p>\r\n</td>\r\n</tr>\r\n<tr>\r\n<td width="138">\r\n<p>9.20am &ndash; 9.50 am</p>\r\n</td>\r\n<td width="300">\r\n<p>World Cancer Day Launch:</p>\r\n<p><strong><em>Key Note Address</em></strong></p>\r\n</td>\r\n<td width="186">\r\n<p>P.S. MoH/</p>\r\n<p>P.S. Public service</p>\r\n</td>\r\n</tr>\r\n<tr>\r\n<td rowspan="6" width="138">\r\n<p>9.50am &ndash; 10.30am <em>(5 mins intro; then 7 mins per panelist)</em></p>\r\n<p>&nbsp;</p>\r\n</td>\r\n<td width="300">\r\n<p>Panelist introduction</p>\r\n</td>\r\n<td width="186">\r\n<p>Moderator - David Makumi - Vice Chair, NCD Alliance-Kenya</p>\r\n</td>\r\n</tr>\r\n<tr>\r\n<td width="300">\r\n<p>Cancer prevention &amp; risk factors ,Screenable cancers</p>\r\n</td>\r\n<td width="186">\r\n<p>Dr. Alfred Karagu</p>\r\n<p>Ag. CEO National Cancer Institute -Kenya</p>\r\n</td>\r\n</tr>\r\n<tr>\r\n<td width="300">\r\n<p>Childhood Cancers - common signs; Risk factors; Treatment &amp; Survivorship</p>\r\n</td>\r\n<td width="186">\r\n<p>Prof Jessie Githanga &ndash; UON/Kenya Childhood Cancers Trust</p>\r\n</td>\r\n</tr>\r\n<tr>\r\n<td width="300">\r\n<p>Managing cancer &ndash; Survivor perspective</p>\r\n</td>\r\n<td width="186">\r\n<p>Muthoni Mate -Cancer Survivor</p>\r\n</td>\r\n</tr>\r\n<tr>\r\n<td width="300">\r\n<p>Service availability &amp; what is Government doing?</p>\r\n<p>Cancer care in Covid-19</p>\r\n</td>\r\n<td width="186">\r\n<p>Dr. Mary Nyangasi &ndash; Head, National Cancer Control Program</p>\r\n</td>\r\n</tr>\r\n<tr>\r\n<td width="300">\r\n<p>Cancer Control and Multisectoral collaboration</p>\r\n</td>\r\n<td width="186">\r\n<p>Dr. Anne Ng&rsquo;ang&rsquo;a &ndash; MOH/ Lions Club of Masaku</p>\r\n</td>\r\n</tr>\r\n<tr>\r\n<td width="138">\r\n<p>10.30am &ndash; 10.55am</p>\r\n</td>\r\n<td width="300">\r\n<p>Question &amp; Answer interactive session</p>\r\n</td>\r\n<td width="186">\r\n<p>Moderator - David Makumi</p>\r\n</td>\r\n</tr>\r\n<tr>\r\n<td width="138">\r\n<p>10.55 - 11.00am</p>\r\n</td>\r\n<td width="300">\r\n<p>Closure &amp; Way Forward</p>\r\n</td>\r\n<td width="186">\r\n<p>Dr. Alfred Karagu</p>\r\n<p>Ag. CEO National Cancer Institute -Kenya</p>\r\n</td>\r\n</tr>\r\n</tbody>\r\n</table>',
        timestamp_from: 1612429200,
        image: '/events/images/WorldCancerDayVirtualLaunch/invite.jpg',
        gallery: ['/events/images/WorldCancerDayVirtualLaunch/invite.jpg'],
        timestamp_to: 1612515600,
        venue: 'Zoom',
        venue_link: 'event',
        isHtml: true,
        email: "",
        phone: "",
        category: 'event',
        canRegister: true,
        hasProgram: true,
    },
    {
        id: '4',
        title: 'Launch of the National Cancer Registry of Kenya System',
        description: '',
        content: '<p><strong>Wednesday, 7th July 2021</strong></p>\r\n<p><strong>Time: 9am - 11am.</strong></p>\r\n<p><strong>Venue: Zoom</strong></p>\r\n<table>\r\n<tbody>\r\n<tr>\r\n<td width="138">\r\n<p>Time</p>\r\n</td>\r\n<td width="300">\r\n<p>Topic</p>\r\n</td>\r\n<td width="186">\r\n<p>Panelist</p>\r\n</td>\r\n</tr>\r\n<tr>\r\n<td width="138">\r\n<p>9.00am</p>\r\n</td>\r\n<td width="300">\r\n<p>Climate setting/ welcoming attendees</p>\r\n</td>\r\n<td width="186">\r\n<p>Moderator &ndash; David &nbsp;Makumi</p>\r\n</td>\r\n</tr>\r\n<tr>\r\n<td width="138">\r\n<p>9.10am &ndash; 9.20am</p>\r\n</td>\r\n<td width="300">\r\n<p>Opening remarks</p>\r\n</td>\r\n<td width="186">\r\n<p>Dr. Ejersa Waqo &ndash; Head, Department of Non-communicable Diseases</p>\r\n</td>\r\n</tr>\r\n<tr>\r\n<td width="138">\r\n<p>9.20am &ndash; 9.50 am</p>\r\n</td>\r\n<td width="300">\r\n<p>World Cancer Day Launch:</p>\r\n<p><strong><em>Key Note Address</em></strong></p>\r\n</td>\r\n<td width="186">\r\n<p>P.S. MoH/</p>\r\n<p>P.S. Public service</p>\r\n</td>\r\n</tr>\r\n<tr>\r\n<td rowspan="6" width="138">\r\n<p>9.50am &ndash; 10.30am <em>(5 mins intro; then 7 mins per panelist)</em></p>\r\n<p>&nbsp;</p>\r\n</td>\r\n<td width="300">\r\n<p>Panelist introduction</p>\r\n</td>\r\n<td width="186">\r\n<p>Moderator - David Makumi - Vice Chair, NCD Alliance-Kenya</p>\r\n</td>\r\n</tr>\r\n<tr>\r\n<td width="300">\r\n<p>Cancer prevention &amp; risk factors ,Screenable cancers</p>\r\n</td>\r\n<td width="186">\r\n<p>Dr. Alfred Karagu</p>\r\n<p>Ag. CEO National Cancer Institute -Kenya</p>\r\n</td>\r\n</tr>\r\n<tr>\r\n<td width="300">\r\n<p>Childhood Cancers - common signs; Risk factors; Treatment &amp; Survivorship</p>\r\n</td>\r\n<td width="186">\r\n<p>Prof Jessie Githanga &ndash; UON/Kenya Childhood Cancers Trust</p>\r\n</td>\r\n</tr>\r\n<tr>\r\n<td width="300">\r\n<p>Managing cancer &ndash; Survivor perspective</p>\r\n</td>\r\n<td width="186">\r\n<p>Muthoni Mate -Cancer Survivor</p>\r\n</td>\r\n</tr>\r\n<tr>\r\n<td width="300">\r\n<p>Service availability &amp; what is Government doing?</p>\r\n<p>Cancer care in Covid-19</p>\r\n</td>\r\n<td width="186">\r\n<p>Dr. Mary Nyangasi &ndash; Head, National Cancer Control Program</p>\r\n</td>\r\n</tr>\r\n<tr>\r\n<td width="300">\r\n<p>Cancer Control and Multisectoral collaboration</p>\r\n</td>\r\n<td width="186">\r\n<p>Dr. Anne Ng&rsquo;ang&rsquo;a &ndash; MOH/ Lions Club of Masaku</p>\r\n</td>\r\n</tr>\r\n<tr>\r\n<td width="138">\r\n<p>10.30am &ndash; 10.55am</p>\r\n</td>\r\n<td width="300">\r\n<p>Question &amp; Answer interactive session</p>\r\n</td>\r\n<td width="186">\r\n<p>Moderator - David Makumi</p>\r\n</td>\r\n</tr>\r\n<tr>\r\n<td width="138">\r\n<p>10.55 - 11.00am</p>\r\n</td>\r\n<td width="300">\r\n<p>Closure &amp; Way Forward</p>\r\n</td>\r\n<td width="186">\r\n<p>Dr. Alfred Karagu</p>\r\n<p>Ag. CEO National Cancer Institute -Kenya</p>\r\n</td>\r\n</tr>\r\n</tbody>\r\n</table>',
        timestamp_from: 16256484,
        image: '/events/images/Screenshot 2021-07-01 210337.png',
        gallery: ['/events/images/Screenshot 2021-07-01 210337.png'],
        timestamp_to: 16256556,
        venue: 'Webex',
        venue_link: 'event',
        isHtml: true,
        email: "",
        phone: "",
        category: 'event',
        canRegister: true,
        hasProgram: true,
    },
    {
        id: '5',
        title: 'Public Hearing on Improving Cancer Management In Kenya',
        description: '',
        content: '<p><strong>Wednesday, 14th July 2021</strong></p>\r\n<p><strong>Time: 9am</strong></p>\r\n<p><strong>Venue: Zoom</strong></p>\r\n<table>Kemundi Hall, Meru Coffee Union, Meru County<tbody>\r\n<tr>\r\n<td width="138">\r\n<p>Time</p>\r\n</td>\r\n<td width="300">\r\n<p>Topic</p>\r\n</td>\r\n</tr>\r\n<tr>\r\n<td width="138">\r\n<p>9.10am &ndash; 9.20am</p>\r\n</td>\r\n<td width="186">\r\n<p>Owing to the Covid-19 protocols and social distancing considerations, the number of attendees during public hearings will be limited to one-third of the capacity of the hall. The public is invited to make applications to attend the public hearings through the respective County Health Promotion Offices. In Meru, the offices are located in Meru Teaching and Referral Hospital. </p>\r\n</td>\r\n</tr>\r\n</tbody>\r\n</table>',
        timestamp_from: 1626253200,
        image: '/events/images/Screenshot 2021-07-01 210337.png',
        gallery: ['/events/images/Screenshot 2021-07-01 210337.png'],
        timestamp_to: 1626307140,
        venue: 'Kemundi Hall, Meru Coffee Union, Meru County',
        venue_link: 'event',
        isHtml: true,
        email: "",
        phone: "",
        category: 'event',
        canRegister: true,
        hasProgram: true,
    },
    {
        id: '6',
        title: 'Public Hearing on Improving Cancer Management In Kenya',
        description: '',
        content: '<p><strong>Friday, 23th July 2021</strong></p>\r\n<p><strong>Time: 9am</strong></p>\r\n<p><strong>Venue: Koblenz Hall, Moi Avenue Off Agakhan walk, Mombasa County</strong></p>\r\n<table>\r\n<tbody>\r\n<tr>\r\n<td width="138">\r\n<p>Time</p>\r\n</td>\r\n<td width="300">\r\n<p>Topic</p>\r\n</td>\r\n</tr>\r\n<tr>\r\n<td width="138">\r\n<p>9.00 am</p>\r\n</td>\r\n<td width="186">\r\n<p>Owing to the Covid-19 protocols and social distancing considerations, the number of attendees during public hearings will be limited to one-third of the capacity of the hall. The public is invited to make applications to attend the public hearings through the respective County Health Promotion Offices. In Meru, the offices are located in Meru Teaching and Referral Hospital. </p>\r\n</td>\r\n</tr>\r\n</tbody>\r\n</table>',
        timestamp_from: 1627030800,
        image: '/events/images/MOH 2-80.jpg',
        gallery: ['/events/images/MOH 2-80.jpg'],
        timestamp_to: 1627063200,
        venue: 'Koblenz Hall, Moi Avenue Off Agakhan walk, Mombasa County',
        venue_link: 'event',
        isHtml: true,
        email: "",
        phone: "",
        category: 'event',
        canRegister: true,
        hasProgram: true,
    },
    {
        id: '7',
        title: 'Kilele Health Symposium',
        description: '',
        content: '<p><strong>Thursday, 26th August 2021</strong></p>\r\n<p><strong>Time: 3pm - 6pm</strong></p>\r\n<p><strong>Venue: 2nd Annual Virtual</strong></p>\r\n<table>\r\n<tbody>\r\n<tr>\r\n<td width="138">\r\n<p>Time</p>\r\n</td>\r\n<td width="300">\r\n<p>Topic</p>\r\n</td>\r\n</tr>\r\n<tr>\r\n<td width="138">\r\n<p>3.00 pm - 6.00pm</p>\r\n</td>\r\n<td width="186">\r\n<p>Survivorship as a link to prevention. </p>\r\n<p>Stakeholders in oncology & Cancer Care Exploring Strategies for harnessing Lived Experiences in Advocacy for Cancer Prevention & Control. </p>\r\n<p>To Partner: kilele@kilelehealth.org. </p>\r\n</td>\r\n</tr>\r\n</tbody>\r\n</table>',
        timestamp_from: 1629990000,
        image: '/events/images/MOH 1-90.png',
        gallery: ['/events/images/MOH 1-90.png'],
        timestamp_to: 1630000800,
        venue: '2nd Annual Virtual',
        venue_link: 'event',
        isHtml: true,
        email: "",
        phone: "",
        category: 'event',
        canRegister: true,
        hasProgram: true,
    },
    {
        id: '8',
        title: 'The 7th Kenya International Cancer Conference',
        description: '',
        content: '<h5>Improving Cancer Outcomes: Innovations, Opportunities &amp; Strategies in the Care Continuum</h5>\r\n\r\n<h4>Call for Abstracts</h4>\r\n\r\n<p>Please submit your abstracts via <a href="https://www.kesho-kenya.org">www.kesho-kenya.org</a>, Deadline for submissions is the 30th July 2022</p>\r\n <h5>Subthemes </h5>\r\n<ul>\r\n<li>Research informing Policy and Practice </li> \r\n<li>Training, Education and Mentorship </li> \r\n<li>Improving access to Cancer Care </li> \r\n<li>Advancements in Nursing, Pediatric, Radiation, Medical and Surgical Oncology </li> \r\n<li>Survivorship and Palliative Care </li> \r\n<li>Innovations in Technology and Precision Medicine</li> \r\n</ul>\r\n<h5>Pre-conference workshops</h5>\r\n<ul>\r\n <li>Radiation Contouring and Planning workshop</li>\r\n<li> Multidisciplinary colorectal surgery workshop</li>',
        timestamp_from: 1669276800,
        image: '/events/images/PHOTO-2022-08-07-16-13-32.jpg',
        gallery: ['/events/images/PHOTO-2022-08-07-16-13-32.jpg'],
        timestamp_to: 1669507199,
        venue: 'Sarova Whitesands, Mombasa, Kenya',
        venue_link: 'event',
        isHtml: true,
        email: "",
        phone: "",
        category: 'event',
        canRegister: true,
        hasProgram: true,
    },
    {
        id: '9',
        title: 'The Role of the Private Sector in Advancing Men’s Health in Africa',
        description: '',
        content: '<div title="Page 5">\r\n    <div>\r\n        <div>\r\n            <div>\r\n                <div>     <p>AHB will convene the session on reducing the cancer burden amongst men in Africa; it will be an avenue for though-provoking conversations on where Africa is as a region regarding the management of cancer. In addition, discussions will be held on how to reduce the cancer treat and burden amongst men on the continent under the theme: &ldquo;It&apos;s more than the beard this November.&quot;</p><strong>Development<br></strong>New developments in the cancer diagnostics and management and what this means for Africa.\r\n                </div>\r\n                <p><br></p><strong>Awareness and prevention</strong><br>The importance of cancer awareness and prevention strategies (prevention strategies, health seeking behavior, advocacy, and policy efforts so far etc.) and the role of the private sector.<br><br><strong>Partnerships</strong><br>Strategies and partnerships towards reducing the cancer burden on the continent (innovative, improved, and current strategies in play)<br><br><strong><br>Africa Men&rsquo;s Health</strong><br>The Role of the Private Sector in Advancing Men&rsquo;s Health in Africa\r\n            </div>\r\n        </div>\r\n        <div>\r\n            <div><br></div>\r\n        </div>\r\n    </div>\r\n</div>',
        timestamp_from: 1669280400,
        image: '/events/images/20220928_AHBSVII Africa Men\'s Health NCI-Kenya 2.jpg',
        gallery: ['/events/images/20220928_AHBSVII Africa Men\'s Health NCI-Kenya 2.jpg'],
        timestamp_to: 1669315500,
        venue: 'Hybrid full day event',
        venue_link: 'event',
        isHtml: true,
        email: "",
        phone: "",
        category: 'event',
        canRegister: true,
        hasProgram: true,
    },
    {
        id: '10',
        title: 'National Cancer Summit',
        description: '',
        content: '<div title="Page 5">\r\n    <div>\r\n        <div>\r\n            <div>\r\n                <div>     <p>In recognition of the need for a more coordinated and multisectoral response to the growing cancer burden in kenya, the national assembly enacted the cancer prevention and control act (no. 15 of 2012) which established the National Cancer Institute of Kenya (NCI Kenya) as a state corporation. The overall mandate of the nci kenya is to coordinate all activities, resources and information related to cancer prevention and control in Kenya.</p>\r\n                </div></br>\r\n                <p>\r\nNCI-kenya recognizes that prioritizing and implementing cancer related interventions requires effective engagement and collaboration among all relevant stakeholders. Therefore, a stakeholder’s convention focused on cancer will take place from 2nd to 4th February 2023, culminating with the commemoration of world cancer day. This convention christened "The National Cancer Summit" is envisioned to bring together all stakeholders to discourse on identified areas of interest and to drive collective & impactful actions.\r\n</p>\r\n            </div>\r\n        </div>\r\n        <div>\r\n            <div><br></div>\r\n\r\n                        \t\t\t\t\t\t\t\t\t\t\t\t<div class="intro-layer animated fadeInUp" data-animation="fadeInUp" style="visibility: hidden;">\r\n                                                                        \t\t\t\t\t\t\t\t\t\t<a href="https://cancersummit.ncikenya.or.ke"  target="_blank" rel="noopener noreferrer" class="theme_button color2">Register for the summit</a>\r\n                                                                        \t\t\t\t\t\t\t\t\t</div>\r\n        </div>\r\n    </div>\r\n</div>',
        timestamp_from: 1675324800,
        image: '/events/images/cancer_summit.png',
        gallery: ['/events/images/cancer_summit.png'],
        timestamp_to: 1675530000,
        venue: 'Safari Park Hotel, Nairobi',
        venue_link: 'event',
        isHtml: true,
        email: "",
        phone: "",
        category: 'event',
        canRegister: true,
        hasProgram: true,
    }
]
